import * as types from 'store/mutation-types'
import Vue from 'vue'
import parseBsTradeRequestUrl from 'utils/parseBsTradeRequestUrl'
import setOptionRequestParams from 'utils/setOptionRequestParams'
import getFixedOrderDetail from 'utils/getLocalFixedOrderDetail'
import getLocalSymbol from 'utils/getLocalSymbol'
import getLocalFixedQuoteDetail from 'utils/getLocalFixedQuoteDetail'

const state = {
  openOrders: [], // 用户待成交订单
  filledOrders: [], // 用户成交订单
  canceledOrders: [], // 用户已取消订单
  curStockOrders: [], // 当前个股订单
  curStockHoldings: [], // 当前个股持仓
  latestOrderStatus: null
}

const mutations = {
  [types.SET_OPEN_ORDERS](state, orders) {
    state.openOrders = orders
  },
  [types.SET_DEAL_ORDERS](state, orders) {
    state.filledOrders = orders
  },
  [types.SET_CANCELED_ORDERS](state, orders) {
    state.canceledOrders = orders
  },
  [types.REFRESH_OPEN_ORDERS](state, orders) {
    orders.forEach(order => {
      const targetOrder = state.openOrders.find(openOrder => {
        if (openOrder.orderId) {
          return openOrder.orderId === order.orderId
        } else {
          return openOrder.id === order.id
        }
      })
      if (targetOrder) {
        Object.assign(targetOrder, order)
      }
    })
  },
  [types.SET_CUR_STOCK_HOLDINGS](state, positions) {
    state.curStockHoldings = positions
  },
  [types.SET_CUR_STOCK_ORDERS](state, orders) {
    state.curStockOrders = orders
  },
  [types.LATEST_ORDER_STATUS](state, time) {
    state.latestOrderStatus = time
  }
}

const getters = {
  openOrders(state) {
    return state.openOrders
  },
  filledOrders(state) {
    return state.filledOrders
  },
  canceledOrders(state) {
    return state.canceledOrders
  },
  curStockHoldings(state) {
    return state.curStockHoldings
  },
  curStockOrders(state) {
    return state.curStockOrders
  },
  latestOrderStatus(state) {
    return state.latestOrderStatus
  }
}
const actions = {
  // 获取全部待成交订单
  getOpenOrders({ getters, commit }) {
    if (getters.isIb) {
      return getIbOrders('~trade/trade/open_order', { secType: 'ALL' }).then(
        orders => {
          commit(types.SET_OPEN_ORDERS, orders)
          return orders
        }
      )
    }
    return getOmnibusOrders('/orders/active', getters.isVirtual).then(
      orders => {
        commit(types.SET_OPEN_ORDERS, orders)
        return orders
      }
    )
  },
  // 获取全部成交订单
  getFulfilledOrders({ getters, commit }, payload) {
    if (getters.isIb) {
      return getIbOrders('~trade/trade/fill_order', {
        secType: payload.secType || 'ALL'
      }).then(orders => {
        commit(types.SET_DEAL_ORDERS, orders)
        return orders
      })
    }
    return getOmnibusOrders('/orders/filled', getters.isVirtual, {
      seg_type: 'SEC',
      since_date: payload.startDate,
      to_date: payload.endDate
    }).then(orders => {
      commit(types.SET_DEAL_ORDERS, orders)
      return orders
    })
  },
  // 获取全部取消订单
  getCanceledOrders({ getters, commit }) {
    if (getters.isIb) {
      return getIbOrders('~trade/trade/inactive_order', {
        secType: 'ALL'
      }).then(orders => {
        commit(types.SET_CANCELED_ORDERS, orders)
        return orders
      })
    }
    return getOmnibusOrders('/orders/inactive', getters.isVirtual).then(
      orders => {
        commit(types.SET_CANCELED_ORDERS, orders)
        return orders
      }
    )
  },

  // 获取当前个股的持仓和订单
  getActiveStockHoldingsAndOrders({ getters, dispatch, commit }, payload) {
    const stock = payload || getters.activeStock
    return dispatch('getStockHoldingsAndOrders', stock).then(res => {
      commit(types.SET_CUR_STOCK_ORDERS, res.orders)
      commit(types.SET_CUR_STOCK_HOLDINGS, res.holdings)
      return res
    })
  },

  // 获取股票的持仓和订单信息
  getStockHoldingsAndOrders({ dispatch, getters }, stock) {
    if (getters.isIb) {
      const symbol = getLocalSymbol(stock)
      return Vue.http.get(`~trade/trade/position_order/${symbol}`).then(res => {
        if (res.data.ret === 0) {
          const orders = getLocalFixedQuoteDetail(
            getFixedOrderDetail(res.data.orders, true)
          )
          const holdings = getLocalFixedQuoteDetail(res.data.positions)
          return {
            orders,
            holdings
          }
        }
      })
    }
    const params = {
      symbol: stock.symbol,
      sec_type: stock.secType
    }
    setOptionRequestParams(params, stock)
    return Promise.all([
      dispatch('getHoldingsBySymbol', stock),
      getOmnibusOrders('/orders/active', getters.isVirtual, params)
    ]).then(([h, o]) => {
      const holdings = getLocalFixedQuoteDetail(h)
      const orders = getLocalFixedQuoteDetail(o)
      return {
        orders,
        holdings
      }
    })
  },
  orderStatusChange({ commit }, timestamp) {
    commit(types.LATEST_ORDER_STATUS, timestamp)
  }
}

// ib 订单接口数据处理
function getIbOrders(url, params) {
  return Vue.http.get(url, { params }).then(res => {
    if (res.data.ret === 0) {
      return getFixedOrderDetail(res.data.items || [], true)
    }
    throw res.data
  })
}

// omnibus 订单接口处理
function getOmnibusOrders(url, isVirtual, params) {
  return Vue.http
    .get(parseBsTradeRequestUrl(url, isVirtual), { params })
    .then(res => {
      if (res.data.status === 'ok') {
        return getFixedOrderDetail(res.data.data || [], false)
      }
      throw res.data
    })
}

export default {
  state,
  mutations,
  getters,
  actions
}
